import { render, staticRenderFns } from "./editGiftGallery.vue?vue&type=template&id=8dbecff0&scoped=true"
import script from "./editGiftGallery.vue?vue&type=script&lang=js"
export * from "./editGiftGallery.vue?vue&type=script&lang=js"
import style0 from "./editGiftGallery.vue?vue&type=style&index=0&id=8dbecff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbecff0",
  null
  
)

export default component.exports